<div>
    <h3>About</h3>
    <p>Pending</p>

    <h3>Deployment</h3>
    The backend is hosted on an Amazon EC2 instance using nginx to route to a subdomain
    hosted on Route 53, and the frontend is hosted on Vercel.
</div>
